import { render, staticRenderFns } from "./sub-ci-color.vue?vue&type=template&id=61d45937&scoped=true&"
import script from "./sub-ci-color.vue?vue&type=script&lang=js&"
export * from "./sub-ci-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d45937",
  null
  
)

export default component.exports